import { useCallback } from 'react';
import { useTranslation } from '../../../i18n/LanguageContext';

/**
 * Texts of Proje Finans Yönetimi and its dialogs (`projectFinance.*`).
 * Stored values (phases, budget options) stay; the Excel file stays Turkish.
 */
const useProjectFinanceText = () => {
  const { t, language, locale } = useTranslation();
  const label = useCallback((key, vars) => t(`projectFinance.${key}`, vars), [t]);
  const formatMoney = useCallback((value, currency = 'TL') => {
    const number = Number(value);
    return `${(Number.isFinite(number) ? number : 0).toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${currency}`;
  }, [locale]);
  const formatDate = useCallback((value) => {
    if (!value) return '';
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleDateString(locale);
  }, [locale]);
  const phaseLabel = useCallback((phase) => {
    const keys = { 'Başlangıç': 'starting', Aktif: 'active', 'Devam Ediyor': 'activeOld', Pasif: 'passive', 'Tamamlandı': 'passiveOld' };
    return keys[phase] ? t(`projectFinance.phases.${keys[phase]}`) : phase;
  }, [t]);
  return { t, language, locale, label, formatMoney, formatDate, phaseLabel };
};

export default useProjectFinanceText;
